import maModalCameraFlow from '@/components/modalCameraFlow'
import maButton from '@/components/button-blue'
import maNotifications from '@/components/notifications'
import maCameraWithSteps from '@/components/cameraComponent/modules/cameraWithSteps'
import maSpinner from '@/components/spinner'
import { mapState, mapActions, mapMutations } from 'vuex'
import { USER_MODULE_NAME } from '@/modules/User/store/types'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_FORMS,
  WARRANTY_CLEAR_FORMS
} from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'

// sentry
import * as Sentry from '@sentry/vue'

export default {
  name: 'damagesCamera',

  mixins: [flowMixin],

  data: function () {
    return {
      spinner: true,
      loading: true,
      photos: [],
      photoCount: 0
    }
  },

  components: {
    maModalCameraFlow,
    maButton,
    maNotifications,
    maSpinner,
    maCameraWithSteps
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyForms: 'forms',
      stateWarrantyCounterMurs: 'counterMurs'
    }),

    ...mapState(USER_MODULE_NAME, {
      stateUserType: 'userType'
    }),

    report() {
      return {
        ...this.damageReport
        //SUPPORT: this.damagedPart.key
      }
    }
  },

  methods: {
    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyGetForms: WARRANTY_GET_FORMS
    }),

    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyClearForms: WARRANTY_CLEAR_FORMS
    }),

    showModal() {
      this.loading = true
      this.spinner = false
      this.$refs.modalDamagesCamera.showModal = true
      this.loading = false
    },

    hideModal() {
      this.resetForms()
      this.$refs.modalDamagesCamera.showModal = false
    },

    handlePhotos(photos) {
      this.photos = photos
      if (this.photos.length === 3) {
        this.$emit('photosAdded', this.photos)
        this.hideModal()
      }
      this.checkPhotoStepper()
    },

    checkPhotoStepper() {
      const checkIcons = document.getElementsByClassName(
        'camera__stepper--circle'
      )
      checkIcons[this.photoCount].classList.add('camera__completed')
      this.photoCount++
    },

    emitTotalPhotos() {
      this.$emit('totalPhotos', this.photoCount)
    },

    /**
     * Checks if the form is valid and sends the updated information to the parent component
     */

    resetForms() {
      this.photoCount = 0
    }
  },

  mounted() {
    setTimeout(() => {
      this.showModal()
    })
  }
}